/*
Copyright 2024 Adobe. All rights reserved.
This file is licensed to you under the Apache License, Version 2.0 (the "License");
you may not use this file except in compliance with the License. You may obtain a copy
of the License at http://www.apache.org/licenses/LICENSE-2.0

Unless required by applicable law or agreed to in writing, software distributed under
the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
OF ANY KIND, either express or implied. See the License for the specific language
governing permissions and limitations under the License.
*/

import { tag as html, TemplateResult } from '../custom-tag.js';

export { setCustomTemplateLiteralTag } from '../custom-tag.js';
export const ImportIcon = ({ width = 24, height = 24, hidden = false, title = 'Import' } = {}):
  | string
  | TemplateResult => {
  return html`<svg
    xmlns="http://www.w3.org/2000/svg"
    width="${width}"
    height="${height}"
    viewBox="0 0 20 20"
    aria-hidden=${hidden ? 'true' : 'false'}
    role="img"
    fill="currentColor"
    aria-label="${title}"
  >
    <path
      d="M8.3252,12.46973c-.29297.29297-.29297.76758,0,1.06055.14648.14648.33789.21973.53027.21973s.38379-.07324.53027-.21973l3-3c.29297-.29297.29297-.76758,0-1.06055l-3-3c-.29297-.29297-.76758-.29297-1.06055,0s-.29297.76758,0,1.06055l1.71973,1.71973H.89453c-.41406,0-.75.33594-.75.75s.33594.75.75.75h9.15039l-1.71973,1.71973Z"
      fill="currentColor"
    />
    <path
      d="M14.75,2.02148H6.25c-1.24023,0-2.25,1.00977-2.25,2.25v1.96777c0,.41406.33594.75.75.75s.75-.33594.75-.75v-1.96777c0-.41309.33691-.75.75-.75h8.5c.41309,0,.75.33691.75.75v11.5c0,.41309-.33691.75-.75.75H6.45312c-.41309,0-.75-.33691-.75-.75v-2.04395c0-.41406-.33594-.75-.75-.75s-.75.33594-.75.75v2.04395c0,1.24023,1.00977,2.25,2.25,2.25h8.29688c1.24023,0,2.25-1.00977,2.25-2.25V4.27148c0-1.24023-1.00977-2.25-2.25-2.25Z"
      fill="currentColor"
    />
  </svg>`;
};
